import React, { useMemo, useState } from "react";
import BlogPostView from "../blog/BlogPostView";
import { BLOG_AUTHORS } from "../blog/blogAuthors";

const today = () => new Date().toISOString().slice(0, 10);

const emptyForm = {
  title: "",
  slug: "",
  author: BLOG_AUTHORS[0]?.id || "666_truth",
  date: today(),
  category: "",
  imageUrl: "",
  body: "<p>First paragraph.</p><p>Second paragraph.</p><p>Third paragraph.</p>",
};

const AdminBlogPostTool = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [showPreview, setShowPreview] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const previewPost = useMemo(
    () => ({
      ...form,
      image: form.imageUrl,
      text: form.body,
    }),
    [form]
  );

  const updateField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
    setMessage({ type: "", text: "" });
  };

  const resetAndClose = () => {
    setOpen(false);
    setShowPreview(false);
    setSubmitting(false);
    setMessage({ type: "", text: "" });
  };

  const logoutToHome = () => {
    window.location.href = "/";
  };

  const publishPost = async () => {
    const password = window.prompt("Enter POST_BLOGPASS to permanently publish this post:");

    if (!password) {
      setMessage({ type: "error", text: "Publish cancelled. Password is required." });
      return;
    }

    try {
      setSubmitting(true);
      setMessage({ type: "", text: "" });

      const response = await fetch("/api/blog/posts", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title: form.title,
          slug: form.slug,
          author: form.author,
          date: form.date,
          category: form.category,
          imageUrl: form.imageUrl,
          body: form.body,
          password,
        }),
      });

      const payload = await response.json().catch(() => null);

      if (payload?.logout) {
        logoutToHome();
        return;
      }

      if (!response.ok) {
        throw new Error(payload?.error || "Unable to publish blog post");
      }

      setMessage({
        type: "success",
        text: `Published permanently: /blog/${payload.post.slug}`,
      });
      setForm(emptyForm);
      setShowPreview(false);
    } catch (error) {
      setMessage({ type: "error", text: error.message || "Unable to publish blog post" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button type="button" className="blog-button blog-admin-launch" onClick={() => setOpen(true)}>
        POST
      </button>

      {open ? (
        <div className="blog-modal-overlay" role="dialog" aria-modal="true" aria-label="Create blog post">
          <div className="blog-modal-panel">
            <div className="blog-modal-header">
              <div>
                <div className="blog-modal-kicker">ADMIN PUBLISHING</div>
                <h2 className="blog-modal-title">Permanent Blog Post</h2>
              </div>

              <button type="button" className="blog-modal-close" onClick={resetAndClose} aria-label="Close">
                ×
              </button>
            </div>

            <div className="blog-form-grid">
              <label className="blog-form-field">
                <span>Title</span>
                <input
                  value={form.title}
                  onChange={(event) => updateField("title", event.target.value)}
                  placeholder="Another New Blog"
                />
              </label>

              <label className="blog-form-field">
                <span>Slug</span>
                <input
                  value={form.slug}
                  onChange={(event) => updateField("slug", event.target.value.toLowerCase())}
                  placeholder="another-new-blog"
                />
              </label>

              <label className="blog-form-field">
                <span>Author</span>
                <select
                  value={form.author}
                  onChange={(event) => updateField("author", event.target.value)}
                >
                  {BLOG_AUTHORS.map((author) => (
                    <option key={author.id} value={author.id}>{author.label}</option>
                  ))}
                </select>
              </label>

              <label className="blog-form-field">
                <span>Date</span>
                <input
                  type="date"
                  value={form.date}
                  onChange={(event) => updateField("date", event.target.value)}
                />
              </label>

              <label className="blog-form-field">
                <span>Category</span>
                <input
                  value={form.category}
                  onChange={(event) => updateField("category", event.target.value)}
                  placeholder="Dispatch"
                />
              </label>

              <label className="blog-form-field">
                <span>Image</span>
                <input
                  value={form.imageUrl}
                  onChange={(event) => updateField("imageUrl", event.target.value)}
                  placeholder="https://cdn.discordapp.com/attachments/.../image.png?..."
                />
              </label>

              <label className="blog-form-field blog-form-field-full">
                <span>Text</span>
                <textarea
                  value={form.body}
                  onChange={(event) => updateField("body", event.target.value)}
                  spellCheck="true"
                />
              </label>
            </div>

            <div className="blog-modal-actions">
              <button
                type="button"
                className="blog-modal-button"
                onClick={() => setShowPreview((current) => !current)}
              >
                {showPreview ? "Hide Preview" : "Preview"}
              </button>

              <button
                type="button"
                className="blog-modal-button"
                onClick={publishPost}
                disabled={submitting}
              >
                {submitting ? "Publishing..." : "+post"}
              </button>
            </div>

            {message.text ? (
              <div className={`blog-modal-message blog-modal-${message.type}`}>
                {message.text}
              </div>
            ) : null}

            {showPreview ? (
              <div className="blog-preview-wrap">
                <div className="blog-preview-heading">Exact Public Preview</div>
                <BlogPostView post={previewPost} preview showBottomButtons />
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AdminBlogPostTool;
